import { identity } from 'ramda';

import { hasValue } from '../../util';

export type Parser = (value: any) => any;

export const defaultParser: Parser = (value) => hasValue(value) ? identity(value) : null;
